import { type SupportForm } from 'dep-common/support-api/types/support-form.type';
import { type UserRole } from 'dep-common/user-api/types/user-role.type';
import { type User } from 'dep-common/user-api/types/user.type';

/**
 * Checks access to a form and returns a boolean indicating whether the user has access to it or not.
 * The user has to have at least one of the roles and the user's country has to be in the list of countries.
 *
 * @param visibility - Visibility object with `roles` and/or `countries` attribute
 * @param userRoles - Roles of the user
 * @param country - Country code of the user
 */
export function hasFormAccess(
  visibility: SupportForm['visibility'],
  userRoles: UserRole[],
  country: User['country'] ,
): boolean {
  let grantAccessBasedOnRoleRight = true;
  if (visibility.roles) {
    // Check if the user has at least one of the required role IDs.
    grantAccessBasedOnRoleRight = userRoles.some((ur) => visibility.roles?.includes(ur.id));
  }

  let grantAccessBasedOnCountry = true;
  if (visibility.countries) {
    // Check if the user has one of the required country codes.
    grantAccessBasedOnCountry = visibility.countries.includes((country ?? '').toUpperCase());
  }

  return grantAccessBasedOnRoleRight && grantAccessBasedOnCountry;
}
